'use strict';

var util = angular.module('gymsystem.util');

util.directive('upcomingactivitylist', ['$rootScope', '$modal', '$filter', 'server', 'live', 'util', function($rootScope, $modal, $filter, server, live, util) {
    return {
        restrict: 'E',
        template: '<customertable config="config" />',
        scope: {
            settings: '='
        },
        link: function($scope) {
            var warnNumBooked = $scope.settings.warnNumBooked;
            var warnHours = $scope.settings.warnHours;

            function showWarning(activity) {
                var now = new Date();
                var target = now.clone().addMinutes(warnHours * 60);
                return activity.start <= target && activity.origin.numBooked <= warnNumBooked;
            }

            function getMinAndMaxAge(activity) {
                var min = activity.minAgeBooked || '';
                var max = activity.maxAgeBooked || '';
                if (!min && !max) { return ''; }
                return min + ' - ' + max + ' ' + $filter('translate')('years old');
            }

            function getNumOfBooked(activity) {
                var numBooked = activity.origin.numBooked;
                var space = activity.origin.space;
                var numBookedStr = '';
                if (showWarning(activity)) {
                    numBookedStr = numBookedStr + ' (' + $filter('translate')('Few booked') + ') ';
                }
                return (numBooked + (space ? ' ' + $filter('translate')('of') + ' ' + space : '')) + numBookedStr;
            }

            var all_columns = [
                {field: 'startDate', title: 'Date', getValue: function(activity) { return util.getShortDate(activity.start); }},
                {field: 'startTime', title: 'Time', getValue: function(activity) { return util.getShortTimePeriod(activity); }},
                {field: 'origin.workoutType.name', title: 'Activity'},
                {field: 'origin.numBooked', title: 'Number of booked', getValue: function(activity) { return getNumOfBooked(activity); }},
                {field: 'age', title: 'Age', getValue: function(activity) { return getMinAndMaxAge(activity); }}
            ];

            var columns = $scope.settings.columns.map(function(column_id) {
                return _.findWhere(all_columns, {field: column_id});
            });

            $scope.add = function(workout) {
                $modal.open({
                    templateUrl: 'views/bookingadd.html',
                    controller: 'WorkoutBookingAddModalCtrl',
                    windowClass: 'huge-modal-window',
                    resolve: {
                        workout: function() {
                            return workout;
                        }
                    }
                });
            };

            $scope.invite = function(workout) {
                server.get('/api/workoutBooking/invites/get', {workout_id: workout.id}).then(function(invites) {
                    invites.forEach($rootScope.transformInvitation);
                    workout.bookings.forEach($rootScope.transformWorkoutBooking);
                    $modal.open({
                        templateUrl: 'views/addmodal.html',
                        controller: 'InviteAddModalCtrl',
                        resolve: {
                            workout: function() {
                                return workout;
                            },
                            invites: function() {
                                return invites;
                            }
                        }
                    });
                });
            };

            $scope.sendMailing = function(workout) {
                var receivers = workout.bookings.map(function(wb) { return $rootScope.getMember(wb.user_id); });
                $scope.pubsub.publish('newmailingdata', {
                    isNewsOrAdvertising: false,
                    sendOption: 'mail',
                    receivers: receivers,
                    options: { 'callCloseOnSuccess': true, 'modalMode': true }
                });
                $modal.open({
                    templateUrl: 'views/mailingnew.html',
                    windowClass: 'huge-modal-window',
                    controller: 'NewMailingCtrl'
                });
            };

            $scope.cancel = function(workout) {
                $modal.open({
                    templateUrl: 'views/cancelworkout.html',
                    controller: 'CancelWorkoutCtrl',
                    resolve: {
                        workout: function() {
                            return workout;
                        }
                    }
                });
            };

            var start = new Date();
            var end = start.clone().addMonths(3);
            function getResourceAllocations() {
                $scope.activities = [];
                server.post2('/api/resourcebooking/resource/get_resource_allocation', {resource_ids: [$rootScope.currentStaffId], start: start, end: end, include_age: true}).then(function(response) {
                    $scope.activities = response;
                });
            }
            getResourceAllocations();

            $scope.activityButtonsConfig = {
                title: 'Shortcuts',
                inline: true,
                alignRight: true,
                buttonClass: function() { return 'btn-primary'; },
                actions: [
                    {title: 'Show', onClick: function(activity) { $rootScope.showWorkout(activity.origin); } },
                    {title: 'Add booking', visible: function(activity) { return $rootScope.canAddBooking(activity.origin); }, onClick: function(activity) { $scope.add(activity.origin); }},
                    {title: 'Invite via mail', visible: function() { return $rootScope.hasPermission('Checkout handling'); }, onClick: function(activity) { $scope.invite(activity.origin); }},
                    {title: 'Send mailing to bookings', visible: function() { return $rootScope.hasPermission('Send mail'); }, onClick: function(activity) { $scope.sendMailing(activity.origin); }},
                    {title: 'Cancel workout', visible: function() { return $rootScope.hasPermission('Send mail'); }, onClick: function(activity) { $scope.cancel(activity.origin); }}
                ]
            };

            var buttons = [
                {title: 'Show', buttonClass: 'btn-success', onClick: function(activity) { $rootScope.showWorkout(activity.origin); }},
                {title: 'Add booking', buttonClass: 'btn-success', visible: function(activity) { return $rootScope.canAddBooking(activity.origin); }, onClick: function(activity) { $scope.add(activity.origin); }},
                {title: 'Invite via mail', buttonClass: 'btn-success', visible: function() { return $rootScope.hasPermission('Checkout handling'); }, onClick: function(activity) { $scope.invite(activity.origin); }},
                {title: 'Send mailing to bookings', buttonClass: 'btn-primary', visible: function() { return $rootScope.hasPermission('Send mail'); }, onClick: function(activity) { $scope.sendMailing(activity.origin); }},
                {title: 'Cancel workout', buttonClass: 'btn-danger', visible: function() { return $rootScope.hasPermission('Send mail'); }, onClick: function(activity) { $scope.cancel(activity.origin); }}
            ];

            var isMobile = $rootScope.isMobile && $rootScope.isMobile();
            $scope.config = {
                getItems: function() { return $scope.activities; },
                hideSearch: true,
                itemFilter: function(activity) { return activity.origin_type === 'Workout'; },
                columns: columns,
                tableOverflow: 'unset',
                renderHtmlMobile: isMobile,
                numOfVisibleColumns: 3
            };

            if (isMobile) {
                $scope.config.buttons = buttons;
            } else {
                $scope.config.multibutton = $scope.activityButtonsConfig;
            }

            live.subscribe({
                type: 'workout',
                scope: $scope,
                callback: function() {
                    getResourceAllocations();
                }
            });

            live.subscribe({
                type: 'workoutbooking',
                scope: $scope,
                callback: function() {
                    getResourceAllocations();
                }
            });
        }
    };
}]);
